import {FormControl, InputLabel, MenuItem, Select} from "@material-ui/core";
import React from "react";
import FlightOptionsContext from "../Session/flightOptionsContext";

export const SelectSortie = "sortie";
export const SelectTail = "tail";

const OptionSelector = (props) => {
    const {value, selectType, disabled, onChange} = props;
    const flightOptions = React.useContext(FlightOptionsContext);

    let label = "label";
    let map = {"default" : {index: 0, name: "default"}}

    switch (selectType) {
        case SelectSortie:
            label = "Flight Type";
            if (flightOptions.sortieDefaults) {
                map = flightOptions.sortieDefaults;
            }
            break;
        case SelectTail:
            label = "Tail Number";
            if (flightOptions.tailNumbers) {
                map = flightOptions.tailNumbers;
            }
            break;
        default:
    }

    return (
        <>
            <FormControl style={{minWidth: 100}} disabled={disabled}>
                <InputLabel htmlFor={label}>
                    {label}
                </InputLabel>
                <Select
                    id={label}
                    value={value}
                    onChange={(event) => onChange(event.target.value)}
                >
                    {Object.keys(map).map((keyName, keyIndex) =>
                        <MenuItem value={keyName} key={keyIndex} >
                            {map[keyName].name}
                        </MenuItem>
                    )}
                </Select>
            </FormControl>
        </>
    );
}

export default OptionSelector;